package app.smartcoding.realrate.domain.usecase

import app.smartcoding.realrate.domain.model.ErrorType
import app.smartcoding.realrate.domain.model.Payment

object PaymentCalculator {

    /**
     * Calculates the total monthly payment.
     * PaymentTotal = MainPayment + Insurance + Fees
     */
    fun calculateTotalPayment(
        mainPayment: Payment.MainPayment,
        insurance: Payment.Insurance,
        fees: Payment.Fees
    ): Payment {
        if (mainPayment.value < 0 || insurance.value < 0 || fees.value < 0) {
            return Payment.Error(ErrorType.NegativeResult)
        }
        val result = mainPayment.value + insurance.value + fees.value
        return Payment.PaymentTotal(result)
    }

    /**
     * Calculates the main payment part based on the total payment.
     * MainPayment = PaymentTotal - Insurance - Fees
     */
    fun calculateMainPayment(
        paymentTotal: Payment.PaymentTotal,
        insurance: Payment.Insurance,
        fees: Payment.Fees
    ): Payment {
        if (paymentTotal.value < 0 || insurance.value < 0 || fees.value < 0) {
            return Payment.Error(ErrorType.NegativeResult)
        }
        val result = paymentTotal.value - insurance.value - fees.value
        if (result < 0) {
            return Payment.Error(ErrorType.NegativeResult)
        }
        return Payment.MainPayment(result)
    }
}